// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"171":"collection","185":"pdp","187":"report-issue","594":"demo","711":"warranty","962":"home"}[chunkId] + "." + {"171":"bf349f7c","185":"2cc5a126","187":"279ed120","594":"9bc533b6","711":"e8daebb7","962":"3d8eeecd"}[chunkId] + ".js";
};